import React, { useState,useEffect, useRef, memo } from "react";

function ChartsTrading() {
  const container = useRef();
  const [darkModeNew, setDarkModeNew] = useState(false);

  const handleModeToggleNew = () => {
    setDarkModeNew(!darkModeNew);
  };

  useEffect(() => {
    const script = document.createElement("script");
    script.src =
      "https://s3.tradingview.com/external-embedding/embed-widget-symbol-overview.js";
    script.type = "text/javascript";
    script.async = true;
    script.innerHTML = `
        {
          "symbols": [
            [
              "BSE:SENSEX|1D|INR"
            ],
            [
              "SPREADEX:NIKKEI|1D|INR"
            ],
            [
              "FTSE|1D"
            ],
            [
              "NASDAQ:NDX|1D|INR"
            ],
            [
              "CAPITALCOM:GOLD|1D"
            ]
          ],
          "chartOnly": false,
          "width": 800,
          "height": 500,
          "locale": "in",
          "colorTheme": "light'",
          "autosize": false,
          "showVolume": false,
          "showMA": false,
          "hideDateRanges": false,
          "hideMarketStatus": false,
          "hideSymbolLogo": false,
          "scalePosition": "right",
          "scaleMode": "Normal",
          "fontFamily": "-apple-system, BlinkMacSystemFont, Trebuchet MS, Roboto, Ubuntu, sans-serif",
          "fontSize": "10",
          "noTimeScale": false,
          "valuesTracking": "1",
          "changeMode": "price-and-percent",
          "chartType": "area",
          "lineWidth": 2,
          "lineType": 0,
          "dateRanges": [
            "1d|1",
            "1m|30",
            "3m|60",
            "12m|1D",
            "60m|1W",
            "all|1M"
          ]
        }`;
    container.current.appendChild(script);
  }, []);

  return (
    <div className="tradingview-widget-container" ref={container} style={{ boxShadow: '0 0 20px rgba(0, 0, 0, 0.5)' }}>
      {/* <button onClick={handleModeToggleNew}>{darkModeNew ? 'Light Mode' : 'Dark Mode'}</button> */}
      <div className="tradingview-widget-container__widget"></div>
    </div>
  );
}

export default memo(ChartsTrading);